// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"fe5c9223","715":"bc17e4cf","772":"fe5c9223"}[chunkId] + ".chunk.css";
};